<template>

  <div>

    <transition
      name="slide-left"
      mode="out-in">

      <search-model
        v-if="!model"
        @leave="$emit('leave')" />

      <info-model
        v-else
        :model="model"
        @leave="$emit('leave')"
        @next="nextPage()"
        @badmodel="changeModel({ btag: model.btag })" />

    </transition>

  </div>

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import SearchModel from './ScreenOne/SearchModel';
import InfoModel from './ScreenOne/InfoModel';

export default {
  components: {
    SearchModel,
    InfoModel,
  },
  computed: {
    ...mapState('buyphones', ['model']),
  },
  methods: {
    ...mapActions('buyphones', ['changeModel', 'getQuestions','getCalc']),
    ...mapMutations('buyphones', ['RESET_MODEL']),

    nextPage() {
      if(this.model && this.model.mobile && this.model.mobile.model==="Смартфон"){
        this.getCalc({
          btag: this.model.btag,
          questions: "",
        })
        this.$emit('changeScreen', {type: 'next', id: 0})
        this.$emit('changeScreen', {type: 'next', id: 1})
        return
      }
      this.getQuestions();
      this.$emit('changeScreen', {type: 'next', id: 0})
    }
  }
}
</script>

<style lang="css">
</style>
